/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LegacyTournamentGroup
 */
export interface LegacyTournamentGroup {
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroup
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroup
     */
    categoryId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroup
     */
    stageId?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LegacyTournamentGroup
     */
    bracket?: string;
}

/**
 * Check if a given object implements the LegacyTournamentGroup interface.
 */
export function instanceOfLegacyTournamentGroup(value: object): value is LegacyTournamentGroup {
    return true;
}

export function LegacyTournamentGroupFromJSON(json: any): LegacyTournamentGroup {
    return LegacyTournamentGroupFromJSONTyped(json, false);
}

export function LegacyTournamentGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyTournamentGroup {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'stageId': json['stageId'] == null ? undefined : json['stageId'],
        'name': json['name'] == null ? undefined : json['name'],
        'bracket': json['bracket'] == null ? undefined : json['bracket'],
    };
}

export function LegacyTournamentGroupToJSON(json: any): LegacyTournamentGroup {
    return LegacyTournamentGroupToJSONTyped(json, false);
}

export function LegacyTournamentGroupToJSONTyped(value?: LegacyTournamentGroup | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'categoryId': value['categoryId'],
        'stageId': value['stageId'],
        'name': value['name'],
        'bracket': value['bracket'],
    };
}

